import React from 'react';

export const WiFiIcon = (props: { fill?: string }) => (
    <svg width="80" height="80" viewBox="0 0 80 80" fill="none" style={{ color: `var(--color-${props.fill})` }} xmlns="http://www.w3.org/2000/svg">
        <path d="M3 29C3 29 15.6235 14 40 14C64.3765 14 77 29 77 29" stroke="currentColor" strokeWidth="3" strokeLinecap="round" />
        <path d="M13 38C13 38 22.2118 27 40 27C57.7882 27 67 38 67 38" stroke="currentColor" strokeWidth="3" strokeLinecap="round" />
        <path d="M21 48C21 48 27.4824 40 40 40C52.5176 40 59 48 59 48" stroke="currentColor" strokeWidth="3" strokeLinecap="round" />
        <circle cx="40" cy="64" r="8" stroke="currentColor" strokeWidth="3" />
    </svg>
);
